export default {
    TARIFFCALCULATORFORM: ".tarifrechner-input form",
    TARIFFCALCULATORBUTTON: '.tarifrechner-input form button[type=submit]',
    PLZ: 'input[data-autocomplete=PostCode]',
    AUTOCOMPLETE_PLZ: "div[autocomplete-for=PostCode]",
    AUTOCOMPLETE_STREET: "input[data-autocomplete=Street]",
    KWH: "input[data-autocomplete=kwh]",
    CITY: 'input[data-autocomplete=City]',
    STREET: "input[data-autocomplete=Street]",
    NUMBER: "input[data-autocomplete=StreetNumber]",
    TAB: "button[role=tab]",
    TABPRIVAT: "button[aria-controls=tarifrechner-privat]",
    TABGEWERBE: "button[aria-controls=tarifrechner-gewerbe]",
    Bodys: "div[bodyswap]",
    ERRORS: {
        OEKOSTROM: "0",
        MIETERSTROM: "1",
        TOLARGEKWH80: "2",
        TOLARGEKWH10: "3"
    },
    IncrementInputs: "div .increment-inputs",
    TarifrechnerResult: "div .tarifrechner-result",
    TarifrechnerFinePrint: "div .result-fineprint",
    Tarifgruppe: "div .tarifgruppe",
    DataAllyDialogShow: (ProductName) => {
        return `div[data-a11y-dialog-show="${ProductName.replace("+", " ")}_strompreisbremse-dialog"]`;
    },
    DataAllyDialog: (ProductName) => {
        return `div[data-a11y-dialog="${ProductName.replace("+", " ")}_strompreisbremse-dialog"]`;
    },
    AssignedProductButton: (ProductName) => {
        return `button[data-tarif="${ProductName.replace("+", " ")}_assigned_product"`;
    },
};
